<template>
  <div v-loading="is_dashboard_loading" class="tickets-dashboard__wrapper">
    <tickets-dashboard-tabs></tickets-dashboard-tabs>
  </div>
</template>

<script>
import ticketDashboardMixins from '../../../../mixins/ticketDashboardMixins';
import TicketsDashboardTabs from './TicketsDashboardComponents/TicketsDashboardTabs.vue';
export default {
  name: "TicketsDashboard",
  components: {
    TicketsDashboardTabs,
  },
  mixins: [ticketDashboardMixins],
  async mounted() {
		this.is_dashboard_loading = true;
    await this.getAllIncidentCategories();
    this.showDateByQueryReport('wtd');
    await this.getTicketsDashboardReports();
		this.is_dashboard_loading = false;
  }
}
</script>

<style>
.tickets-dashboard__wrapper .el-tabs__header {
	background-color: #FFF;
	margin: 0;
	padding: 6px 15px;
}
.tickets-dashboard__wrapper .el-tab-pane {
	padding: 0;
}
.tickets-dashboard__wrapper .capitalize {
	text-transform: capitalize;
}
.tickets-dashboard__wrapper .cursor-pointer {
	cursor: pointer;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .el-tabs__nav-wrap::after {
	background-color: transparent;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .el-tabs__active-bar.is-top {
	width: 92px !important;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .el-tabs__active-bar {
	background-color: #e29d5a;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .el-tabs__item.is-active {
	color: #e29d5a;
	font-size: 14px;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .el-tabs__item.is-active .description-text {
	padding-left: 4px;
	font-weight: 600;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .tickets-dashboard-summary {
	width: 100%;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .tickets-dashboard-summary .content-wrapper {
	padding: 25px;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	margin-bottom: 20px;
	background-color: #FFF;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .tickets-dashboard-summary .content-wrapper .content-items {
	width: max-content;
	text-align: left;
	display: flex;
	flex-direction: row;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .tickets-dashboard-summary .content-wrapper .content-items .content-title {
	font-size: 14px;
	font-weight: 700;
	color: #333;
	width: max-content;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .tickets-dashboard-summary .content-wrapper .content-items .content-value {
	font-size: 14px;
	font-weight: 700;
	color: #e29d5a;
	padding: 0 15px;
	width: max-content;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .ticket-dashboard-filters {
	background: #fff;
	padding: 25px;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .ticket-dashboard-filters .ticket-dashboard-filter-items-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .ticket-dashboard-filters .ticket-dashboard-filter-items-wrapper .ticket-dashboard-filter-item {
	display: flex;
	flex-direction: column;
	width: max-content;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .ticket-dashboard-filters .ticket-dashboard-filter-items-wrapper .ticket-dashboard-filter-item .drop-down-label {
	font-size: 14px;
	font-weight: 700;
	color: #333;
	margin-bottom: 4px;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .graph-container {
	margin: 20px 0;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .graph-container .tickets-dashboard-graph-container {
	background-color: #fff;
	width: 100%;
	height: 600px;
	padding: 25px;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .table-container {
	margin-top: 20px;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .table-container .tickets-table-container {
	background-color: #fff;
	padding: 25px;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .table-container .tickets-table-container .tickets-table-action-btn {
	color: #e29d5a;
	text-decoration: underline;
	font-weight: 500;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .table-container .icon-black {
	color: #333;
	font-size: 14px;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .el-input__inner, .tickets-dashboard__wrapper .tickets-dashboard-tabs input {
	text-transform: capitalize;
	text-overflow: ellipsis;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .el-select .el-input.is-focus .el-input__inner {
	overflow: scroll;
	text-overflow: ellipsis;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .el-select .el-input .el-input__inner {
	overflow: scroll;
	text-overflow: ellipsis;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .tickets-table-container .el-table {
  color: #333333;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .tickets-table-container .el-table th.el-table__cell {
  border-top: 1px solid #ebeef5 !important;
}
.tickets-dashboard__wrapper .tickets-dashboard-tabs .tickets-table-container .el-table .el-table__body tbody tr:first-child td .cell {
  font-weight: 700;
}
</style>